export enum Locales {
  enGB = 'en-GB',
  esES = 'es-ES',
  ptBR = 'pt-BR'
}

export const LOCALES = [
  { value: Locales.enGB, caption: 'EN' },
  { value: Locales.esES, caption: 'ES' },
  { value: Locales.ptBR, caption: 'PT' }
]
